import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {Card, Col, Divider, Form, Input, InputNumber, message, Row, Space} from "antd";
import {useForm} from "antd/lib/form/Form";
import {useRequest} from "ahooks";
import * as api from '../../../../apis/platforms/admin/hospital'
import {useHistory} from "react-router-dom";
import {useParams} from "react-router";
import {EditOutlined, StopOutlined, RollbackOutlined, PlayCircleOutlined} from "@ant-design/icons";


export default function HospitalEdit() {

    const history = useHistory()
    const [form] = useForm()
    const {id} = useParams<any>()
    const [hospitalData, setHospitalData] = useState<any>({})
    const [canEdit, setCanEdit] = useState(false)

    useEffect(() => {
        if (id) {
            getHospitalDetail(id)
        } else {
            setCanEdit(true)
        }
    }, [id])

    const {loading: submitHospitalLoading, run: submitHospital} = useRequest(api.modifyHospital, {
        manual: true,
        onSuccess(res) {
            message.success("操作成功")
            setCanEdit(false)
        }
    })

    const {run: getHospitalDetail} = useRequest(api.getHospitalDetail, {
        manual: true,
        onSuccess: (res) => {
            setHospitalData(res.data.data)
            form.setFieldsValue(res.data.data)
        }
    })

    const {run: switchHospital} = useRequest(api.switchHospital, {
        manual: true,
        onSuccess(res) {
            message.success("操作成功")
            getHospitalDetail(id)
        }
    })

    function doSubmit() {
        form.validateFields().then(values => {
            submitHospital(values)
        })
    }

    return (
        <PageHeaderLayout withFooterBar={canEdit}
                          onOk={doSubmit}
                          onCancel={() => setCanEdit(false)}
                          btnLoading={submitHospitalLoading}
        >
            <Card title={'基本信息'} extra={
                <Space split={<Divider type="vertical"/>} style={{fontWeight: "bold"}}>
                    <a onClick={() => setCanEdit(true)}><EditOutlined/> 修改</a>
                    {!hospitalData.status ?
                        <a onClick={() => switchHospital(id)}><PlayCircleOutlined/> 启用</a>
                        :
                        <a onClick={() => switchHospital(id)}><StopOutlined/> 停用</a>
                    }
                    <a onClick={() => history.goBack()}><RollbackOutlined/> 返回</a>
                </Space>
            }>
                <Form
                    disabled={!canEdit}
                    form={form}
                    labelCol={{span: 5}}
                >
                    <Form.Item name={'id'} noStyle>
                        <Input style={{display: 'none'}}/>
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="医院编码"
                                name="code"
                            >
                                <Input disabled/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="医院名称"
                                name="name"
                                rules={[{required: true, message: '请填写医院名称'}]}
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="检验科年收入"
                                name="clinlabAnnualIncome"
                            >
                                <InputNumber style={{width: '100%'}} addonAfter="万"/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="床位数"
                                name="beds"
                            >
                                <InputNumber style={{width: '100%'}}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="检验科负责人"
                                name="clinlabLeader"
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="检验科负责人电话"
                                name="clinlabLeaderTel"
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="分管院长"
                                name="dean"
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </PageHeaderLayout>
    )
}